module.exports = __webpack_public_path__ + "static/media/ic_no_signature.d0e1bf1c.svg";